export default function BisneLogo({ size = 48, className = '' }) {
  return (
    <img
      src="/logo.png"
      alt="Bisne Logo"
      width={size}
      height={size}
      className={`object-contain ${className}`}
    />
  );
}
